module.exports = __webpack_public_path__ + "znamenka-a-kozni-vyrustky_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/znamenka-a-kozni-vyrustky_1_after.jpg
// module id = 1005
// module chunks = 0